import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, TopicStatus, TopicType } from './index';
import { PaginationProps } from '../types';

export type TopicListData = AnyObject

export type TopicListResponse = TopicListData
export type TopicListColumns = 'title' | 'createdAt' | 'updatedAt' | 'numberOfPosts' | 'numberOfSubscribers';

export type TopicListGetParams = PaginationProps & {
  search?: string;
  isSeoReady?: boolean;
  topicType?: TopicType;
  status?: TopicStatus;
  usaStateId?: number;
}

export const topicList = (payload: TopicListGetParams): Action<TopicListGetParams> => ({
  type: actions.topicListTrigger.toString(),
  payload,
});

export const topicListClear = (): Action => ({
  type: actions.topicListClear.toString(),
});

export const topicListErrorClear = (): Action => ({
  type: actions.topicListErrorReset.toString(),
});

export function* topicListRequestSaga({ payload }: Action<TopicListGetParams>) {
  yield put({
    type: actions.topicListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.topicListError.toString(),
      payload: {
        message: 'TopicList: Parameters not passed.',
      },
    });

    return;
  }

  const params = new URLSearchParams(Object.entries(payload).filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}topics?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TopicListData, TopicListResponse>(
    response,
    actions.topicListSuccess.toString(),
    actions.topicListError.toString(),
    false,
    (topicListData) => topicListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.topicListTrigger.toString(),
    defaultProcessingSaga(
      topicListRequestSaga,
      {
        error: actions.topicListError.toString(),
        locationCancel: actions.topicListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.topicListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.topicListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.topicListErrorReset.toString(),
    });
  });
}
